module.exports = __webpack_public_path__ + "static/mentoring-d5c0e22cc0c6e228d3feb2cb4a073ab4.jpg";